export const gridStyle = ({ palette = {} }) => ({
  fontSize: 12,
  maxHeight: 264,
  overflow: 'hidden auto',

  '& .ms-DetailsHeader': {
    borderTop: 'none',
    borderBottom: '1px solid #979797',
  },

  '& .ms-DetailsRow': {
    borderBottom: `1px solid ${palette.neutralLighter}`,
  },

  '& .ms-DetailsHeader-cell, .ms-DetailsRow-cell': {
    borderRight: 'none',
  },

  '& .ms-DetailsHeader-cellTitle': {
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',

    '& i.ms-Icon': {
      paddingRight: 4,
    },
  },

  '& .ms-DetailsRow-cell': {
    alignSelf: 'center',
  },

  '& .qi-column-kpi, & .qi-column-search-interest': {
    textAlign: 'end',
  },

  '& .qi-header-kpi, & .qi-header-search-interest': {
    '& .ms-DetailsHeader-cellTitle': {
      justifyContent: 'flex-start',
    },
  },

  '& .qi-header-kpi .ms-DetailsHeader-cellTitle': {
    paddingRight: 0,
  },

  '& .qi-header-metrics': {
    display: 'flex',

    '& .qi-metrics-name': {
      flexGrow: 1,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
});
